import { RouterProvider } from 'react-router-dom';
import { ToastProvider } from '@immo/ui-kit';
import { ModalDefaults } from '@/components/modal-defaults';
import { ReleaseNoticeBridge } from '@/components/release-notice-bridge';
import { I18nProvider } from '@/i18n/provider';
import { router } from '@/routes';

export function App() {
  return (
    <I18nProvider>
      <ModalDefaults>
        {/* The operator surfaces confirm a completed action with a toast (the
            valuation approval gate, IMM-475.2); inline banners stay for refusals. */}
        <ToastProvider>
          <ReleaseNoticeBridge />
          <RouterProvider router={router} />
        </ToastProvider>
      </ModalDefaults>
    </I18nProvider>
  );
}
